import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useToast } from '../hooks/use-toast';
import { serviceOptions as fbServiceOptions } from '../data/mock';
import { useContent } from '../context/ContentContext';
import { CheckCircle2, Calendar } from 'lucide-react';
import { saveSubmission } from '../lib/store';

const AppointmentModal = ({ open, onClose }) => {
  const { serviceOptions = fbServiceOptions } = useContent();
  const { toast } = useToast();
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', email: '', service: '', message: '' });

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    saveSubmission('appointments', { ...form, date: new Date().toISOString() });
    setSubmitted(true);
    toast({ title: 'Appointment Requested!', description: 'We will contact you shortly to confirm.' });
    setTimeout(() => {
      setSubmitted(false);
      setForm({ name: '', phone: '', email: '', service: '', message: '' });
      onClose();
    }, 2200);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2 text-brand-bluedark">
            <Calendar className="text-brand-green" /> Request an Appointment
          </DialogTitle>
        </DialogHeader>
        {submitted ? (
          <div className="py-10 flex flex-col items-center text-center">
            <CheckCircle2 size={56} className="text-brand-green mb-4" />
            <h3 className="font-display font-bold text-xl text-brand-bluedark">Thank you!</h3>
            <p className="text-slate-500 mt-1">Your request has been received. We’ll be in touch soon.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 pt-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <Label>Full Name *</Label>
                <Input required value={form.name} onChange={(e) => update('name', e.target.value)} placeholder="John Doe" />
              </div>
              <div className="space-y-1.5">
                <Label>Phone *</Label>
                <Input required value={form.phone} onChange={(e) => update('phone', e.target.value)} placeholder="(970) 000-0000" />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label>Email</Label>
              <Input type="email" value={form.email} onChange={(e) => update('email', e.target.value)} placeholder="you@email.com" />
            </div>
            <div className="space-y-1.5">
              <Label>Type of Service Needed *</Label>
              <Select value={form.service} onValueChange={(v) => update('service', v)} required>
                <SelectTrigger><SelectValue placeholder="Select a service" /></SelectTrigger>
                <SelectContent>
                  {serviceOptions.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-1.5">
              <Label>Message</Label>
              <Textarea value={form.message} onChange={(e) => update('message', e.target.value)} placeholder="Tell us about the issue..." rows={3} />
            </div>
            <Button type="submit" className="w-full bg-brand-green hover:bg-brand-greendark text-white font-semibold h-11">Submit Request</Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AppointmentModal;
